import { apiClient } from "./ApiClient";

export const fetchCountryPrices = async ({
  skip = 0,
  limit = 20,
  currency = "USD",
  popular = false,
  location,
  name,
} = {}) => {
  const params = {
    skip,
    limit,
    currency,
    popular,
  };

  if (location) params.location = location;
  if (name) params.name = name;

  const { data } = await apiClient.get("/package/country/prices", { params });
  return data;
};

export async function fetchCountriesByRegion({ regionId, skip = 0, limit = 300 }) {
  const { data } = await apiClient.get("/country/batch", {
    params: {
      skip,
      limit,
      region_id: regionId,
    },
  });
  return data.items;
}
